import {
  createStyles,
  Dialog,
  DialogActions,
  IconButton,
  makeStyles,
  Theme,
  Typography,
} from '@material-ui/core'
import { Autorenew, Close } from '@material-ui/icons'
import React, { cloneElement, useState } from 'react'
import { useTranslate } from 'react-admin'
import Button from './customized-mui-components/Button'
import DraggableComponent from './DraggableComponent'

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    dialogProperty: {
      marginBottom: theme.spacing(1),
    },
    confirmDialog: {
      minWidth: '300px',
    },
    actionsButton: {
      margin: '2%',
      width: '96%',
    },
    bulkStateActions: {
      height: '16px',
      background: 'rgba(0,0,0,0.2)',
      minWidth: '300px',
      userSelect: 'none',
    },
    bulkProgressTitle: {
      paddingLeft: '10px',
      width: '100%',
    },
    bulkProgressCloseButton: {
      margin: 0,
    },
  }),
)

const RecurringMethodDialog = ({ ...props }) => {
  const { actions, handleCloseDialog, open } = props
  const classes = useStyles()
  const translate = useTranslate()

  return (
    <Dialog
      open={open}
      onClose={handleCloseDialog}
      disableBackdropClick
      disableEscapeKeyDown
      PaperComponent={DraggableComponent}
      aria-labelledby="draggable-confirm-title"
      className={classes.confirmDialog}
      onClick={(e) => e.stopPropagation()}
    >
      <DialogActions
        className={classes.bulkStateActions}
        style={{ cursor: 'move' }}
      >
        <Typography
          className={classes.bulkProgressTitle}
          id="draggable-confirm-title"
        >
          {translate('resources.recurring-jobs.dialogs.pickMethod.title')}
        </Typography>
        <IconButton
          size="small"
          className={classes.bulkProgressCloseButton}
          onClick={handleCloseDialog}
        >
          <Close fontSize="small" />
        </IconButton>
      </DialogActions>
      <DialogActions>
        {React.Children.map(actions, (action) =>
          cloneElement(action, { handleCloseMethodDialog: handleCloseDialog }),
        )}
      </DialogActions>
    </Dialog>
  )
}

export const RecurringMethodButton = ({ ...props }) => {
  const { actions, disabled, ...rest } = props
  const [dialogOpen, setDialogOpen] = useState<boolean>(false)

  const handleCloseDialog = () => {
    setDialogOpen(false)
  }

  const handleOpenDialog = () => {
    setDialogOpen(true)
  }

  return (
    <>
      <RecurringMethodDialog
        actions={actions}
        handleCloseDialog={handleCloseDialog}
        open={dialogOpen}
      />
      <Button
        variant="contained"
        color="primary"
        label=""
        useSmallVersionBreakpoint={false}
        disabled={disabled}
        onClick={handleOpenDialog}
        {...rest}
      >
        <Autorenew />
      </Button>
    </>
  )
}
